export default __webpack_public_path__ + "static/media/logo_borde.6f062b10.png";